import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';

import styles from "./styles";

const useStyles = makeStyles(styles);
export default function Loader(){
    const classes = useStyles();

    return(
        <Box className={classes.loadingPage}>
            <CircularProgress />
        </Box>
    )
}